import { RouteProps } from "react-router-dom";
import Layout from "../Layouts/Layout";
import Home from "../Pages/Home/Home";
import AllUsers from "../Pages/AllUsers/AllUsers";
import User from "../Pages/AllUsers/User";
import PunchList from "../Pages/PunchList/PunchList";
import PunchListDetails from "../Pages/PunchList/Form/Details/Details";
import PunchListForm from "../Pages/PunchList/Form/Form";
import SiteMap from "../Pages/PunchList/Form/SiteMap/SiteMap";
import Options from "../Pages/PunchList/Options/Options";
import View from "../Pages/PunchList/Options/View/View";
import PunchListsDetailsPage from "../Pages/PunchList/DetailsPage/DetailsPage";
import Table from "../Pages/PunchList/Options/View/Table/Table";
import MyAssignment from "../components/User/MyAssignment";
import ListComment from "../components/CoreComponents/Comments/Comment/Comment";
import AllChangeLogs from "../Pages/ChangeLog/AllChangeLogs";
import ChangeLogDetails from "../Pages/ChangeLog/ChangeLogDetails";
import DrawingLayouts from "../Pages/Projects/DrawingLayouts/DrawingLayouts.tsx";
import MapView from "../Pages/Projects/DrawingLayouts/MapView.tsx";
import AllAdHocUnits from "../Pages/Unit/AllAdHocUnits";
import CreateAdHocUnit from "../Pages/Unit/CreateAdHocUnit";
import AllAdHocUnitsByProject from "../Pages/Unit/AllAdHocUnitsByProject";
import AdHocUnitDetails from "../Pages/Unit/AdHocUnitDetails";
import PunchListEditImagesPage from "../Pages/PunchList/DetailsPage/PunchListEditImagesPage.tsx";
import PendingSyncItems from "../Pages/PendingSyncItems/PendingSyncItems.tsx";
import TasksDD from "../Pages/Tasks/TasksDD.tsx";
import CheckListDD from "../Pages/Tasks/CheckList/CheckList.tsx";
import DetailsDD from "../Pages/Tasks/CheckList/Details/Details.tsx";
import Projects from "../Pages/Projects/Projects.tsx";
import ProjectMaps from "../Pages/Projects/ProjectMaps/ProjectMaps.tsx";
import MapsDrawings from "../Pages/Projects/DrawingLayouts/MapsDrawings/MapsDrawings.tsx";
import ModelsManagment from "../Pages/ModelInespections/ModelInespections.tsx";
import InspectionsDetails from "../Pages/InspectionsDetail/InspectionsDetails.tsx";
import RolePermissions from "../Pages/RolePermissions/RolePermissions.tsx";

type TRoute = {
    [key: string]: {
        Layout: React.FC<{ children?: React.ReactNode }>;
        Props: RouteProps;
        Component: React.FC;
        addToMenu?: boolean;
        LazyLoaded?: boolean;
    }
}
export const routes: TRoute = {
    Home: {
        Layout,
        Props: {
            path: "/",
        },
        Component: Home,
        addToMenu: true,
    },
    Projects: {
        Layout,
        Props: {
            path: "/Projects",
        },
        Component: Projects,
        addToMenu: true,
        LazyLoaded: true
    },
    InspectionsDetail: {
        Layout,
        Props: {
            path: "/Checklists",
        },
        Component: InspectionsDetails,
        addToMenu: true,
    },
    ModelInspections: {
        Layout,
        Props: {
            path: "/ModelInspections",
        },
        Component: ModelsManagment,
        addToMenu: true,
        // LazyLoaded: true
    },
    CheckListManagement: {
        Layout,
        Props: {
            path: "/ChecklistsManagement",
        },
        Component: InspectionsDetails,
        addToMenu: true,
        // LazyLoaded: true
    },
    AllUsers: {
        Layout,
        Props: {
            path: "/AllUsers",
        },
        Component: AllUsers,
        addToMenu: true,
    },
    AssignmentUsers: {
        Layout,
        Props: {
            path: "/ProjectAssignments/:projectName",
        },
        Component: AllUsers,
        addToMenu: true,
    },
    UserEdit: {
        Layout,
        Props: {
            path: "/AllUsers/Edit/:uuid",
        },
        Component: User,
    },
    UserCreate: {
        Layout,
        Props: {
            path: "/AllUsers/Create",
        },
        Component: User,
    },
    RolePermissions: {
        Layout,
        Props: {
            path: "/RolePermissions",
        },
        Component: RolePermissions,
        addToMenu: true,
    },
    AdHocUnits: {
        Layout,
        Props: {
            path: "/AdHocUnits",
        },
        Component: AllAdHocUnits,
        addToMenu: true,
    },
    AdHocUnitsByProject: {
        Layout,
        Props: {
            path: "/AdHocUnits/:ProjectNumber",
        },
        Component: AllAdHocUnitsByProject,
    },
    AdHocUnitDetails: {
        Layout,
        Props: {
            path: "/AdHocUnits/:ProjectNumber/:AdhocUuid",
        },
        Component: AdHocUnitDetails,
    },
    CreateAdHocUnit: {
        Layout,
        Props: {
            path: "/AdHocUnits/Create",
        },
        Component: CreateAdHocUnit
    },
    PunchListForm: {
        Layout,
        Props: {
            path: "/PunchList/Form/:type/:id",
        },
        Component: PunchListForm,
    },
    PunchListDetails: {
        Layout,
        Props: {
            path: "/PunchList/Details/:punchListId",
        },
        Component: PunchListDetails,
    },
    SiteMap: {
        Layout,
        Props: {
            path: "/PunchList/SiteMap/:type/:id",
        },
        Component: SiteMap,
    },
    PunchList: {
        Layout,
        Props: {
            path: "/PunchList",
        },
        Component: PunchList,
        addToMenu: true,
    },
    PunchListView: {
        Layout,
        Props: {
            path: "/PunchList/:viewType/view",
        },
        Component: View,
    },
    PunchListDisciplineOption: {
        Layout,
        Props: {
            path: "/PunchListDiscipline/:disciplineId",
        },
        Component: Options,
    },
    PunchListsDisciplineView: {
        Layout,
        Props: {
            path: "/PunchListDiscipline/:disciplineId/view",
        },
        Component: View,
    },

    PunchListsDisciplineViewTable: {
        Layout,
        Props: {
            path: "/PunchListDiscipline/:disciplineId/view/:listStatus/:assignationFilter",
        },
        Component: Table,
    },
    PunchListsViewTable: {
        Layout,
        Props: {
            path: "/PunchList/:viewType/view/:listStatus",
        },
        Component: Table,
    },

    PunchListsDetailsPage: {
        Layout,
        Props: {
            path: "/PunchList/DetailsPage/:punchListId",
        },
        Component: PunchListsDetailsPage,
    },
    PunchListsDetailsEditImagesPage: {
        Layout,
        Props: {
            path: "/PunchList/DetailsPage/:punchListId/Image",
        },
        Component: PunchListEditImagesPage,
    },
    MyAssignment: {
        Layout,
        Props: {
            path: "/MyAssignment",
        },
        Component: MyAssignment,
    },

    Comment: {
        Layout,
        Props: {
            path: "/Comment/:commentUuid",
        },
        Component: ListComment,
    },

    ChangeLog: {
        Layout,
        Props: {
            path: "/ChangeLog/:changelogUuid",
        },
        Component: ChangeLogDetails,
    },

    AllChangeLogs: {
        Layout,
        Props: {
            path: "/ChangeLogs",
        },
        Component: AllChangeLogs,
        addToMenu: true,
    },

    DrawingLayouts: {
        Layout,
        Props: {
            path: "/DrawingLayouts",
        },
        Component: DrawingLayouts,
    },
    DrawingLayoutsMap: {
        Layout,
        Props: {
            path: "/DrawingLayouts/MapView/:layoutId/:punchlistId?",
        },
        Component: MapView,
    },
    PendingSyncItems: {
        Layout,
        Props: {
            path: "/PendingSyncItems",
        },
        Component: PendingSyncItems,
    },
    TasksDD: {
        Layout,
        Props: {
            path: "/TasksDD",
        },
        Component: TasksDD,
    },
    CheckListDD: {
        Layout,
        Props: {
            path: "/CheckListDD/:path",
        },
        Component: CheckListDD,
    },
    CheckListDetailsDD: {
        Layout,
        Props: {
            path: "/CheckListDetailsDD/:path",
        },
        Component: DetailsDD,
    },
    ProjectMaps: {
        Layout,
        Props: {
            path: "/ProjectMaps/:projectId",
        },
        Component: ProjectMaps,
    },
    MapsDrawings: {
        Layout,
        Props: {
            path: "/MapsDrawings",
        },
        Component: MapsDrawings,
        addToMenu: true,
    },
};
